<template>
  <div class="stage stage--full-size" v-if="visible" data-stage=5>
      <div class="contents" v-if="opened">
          <div class="scroll-height" v-on:scroll="checkIfNeedsMore" ref="scrollElm">

            <div ref="altContainer">

              <template v-if="alternatives.length">
                  <alt-slot
                      v-for="day in alternatives"
                      v-bind:key="day.date.getTime()"
                      :day="day"
                      :header="DateService.friendlyDate(day.date)"
                      :times="day.times"
                      :placeholder="null"
                      v-on:seeMore="seeMore(day.date)"
                      v-on:selectTime="selectTime">
                  </alt-slot>
              </template>

              <template v-if="loading">
                  <alt-slot
                      v-bind:key="n"
                      v-for="n in 7"
                      :placeholder="true">
                  </alt-slot>
              </template>

              <alt-slot v-if="appendInProgress"
                  :placeholder="true">
              </alt-slot>

            </div>

          </div>
      </div>
  </div>
</template>

<script>
  import dropDown from './dropDown'
  import altSlot from './altSlot'
  import DateService from '../services/DateService'
  import AlternativesProvider from '../services/AlternativesProvider'

  export default {
    name: 'altStage',
    props: [
      'visible',
      'opened',
      'booking'
    ],
    components: {
      dropDown,
      altSlot
    },
    data () {
      return {
        loading: true,
        DateService,
        appendInProgress: false,
        alternatives: [],
        offset: 0
      }
    },
    methods: {
      checkIfNeedsMore () {
        if ((this.isScrolledToBottom() || !this.contentsReachesBottom()) && !this.appendInProgress) {
          this.offset += 1
          this.appendAlternatves()
        }
      },

      appendAlternatves () {
        this.appendInProgress = true

        return this.alternativesProvider.requestAlternatives(this.offset)
          .then((alternatives) => {
            this.alternatives.push(...alternatives)
            this.appendInProgress = false
          })
      },

      requestAlternatives () {
        this.loading = true
        this.alternatives = []

        return this.alternativesProvider.requestAlternatives(this.offset)
          .then((alternatives) => {
            this.alternatives = alternatives
            this.loading = false

            this.$nextTick(() => {
              this.checkIfNeedsMore()
            })
          })
      },

      isScrolledToBottom () {
        const tolerance = 50
        const elm = this.$refs.scrollElm

        return elm.scrollHeight - elm.scrollTop <= (elm.clientHeight + tolerance)
      },

      contentsReachesBottom () {
        const elm = this.$refs.scrollElm
        const container = this.$refs.altContainer

        return container.clientHeight >= elm.clientHeight
      },

      seeMore (date) {
        this.$emit('seeMoreAlternativesForDate', date)
      },

      selectTime (date, time) {
        this.$emit('selectAlternativeStartTime', date, time)
      }
    },
    mounted () {
      this.alternativesProvider = new AlternativesProvider(this.$root.booking)

      this.alternativesProvider.setUrlOptions({
        source: this.$root.dmnOptions.from
      })
    }
  }
</script>



// WEBPACK FOOTER //
// altStage.vue?028e8663